<template>
    <div>
      <h2>Settings</h2>
      <div class="qbo-settings">
          <button v-if="HasQboToken === false" class="qbo-link-btn" @click="startQboOAuth" @mouseover="isHovered = true" @mouseleave="isHovered = false">
            <img :src="isHovered ? hoverImage : defaultImage" alt="Connect to Quickbooks" />
          </button>
          <div v-else id="QBOConnected">
            QBO Connected
          </div>
      </div>
      <div>
        <button @click="CheckInvoices">Sales check</button>
      </div>
    </div>
  </template>
  
<script setup>
import axios from 'axios';
import defaultImage from '../assets/C2QB_green_btn_med_default.png';
import hoverImage from '../assets/C2QB_green_btn_med_hover.png';
import { useErrorHandling } from '../composables/errorHandling';
import { useToken } from '../composables/useToken';
import { ref, onMounted } from 'vue';

const { handleApiError } = useErrorHandling();
const { GetToken } = useToken();

const HasQboToken = ref(false);
const isHovered = ref(false);

onMounted(() => {
    CheckQboToken();
});

const CheckQboToken = async () => {

    const data = {
        SessionToken: GetToken()
    };

    const endpoint = `${process.env.VUE_APP_BASE_URL}/qbo/check`;

    const result = await axios.post(endpoint, data)
    .then(response => {
        return response.data;
    })
    .catch(error => {
        handleApiError(error);
    });
    console.log('QBO check', result);
    HasQboToken.value = result;
}

const startQboOAuth = () => {
    const OAUTH_URL = `${process.env.VUE_APP_BASE_URL}/qbo/connect`;
    window.location.href = OAUTH_URL;
};

const CheckInvoices = async () => {
    const data = {
        SessionToken: GetToken()
    };

    const endpoint = `${process.env.VUE_APP_BASE_URL}/qbo/orders`;

    const result = await axios.post(endpoint, data)
    .then(response => {
        return response.data;
    })
    .catch(error => {
        handleApiError(error);
    });

    console.log('Invoices info', result);
};

</script>
  
  <style scoped>
  .qbo-settings {
      margin-top: 20px;
  }
  
  /* QBO Button Style */
  .qbo-link-btn {
      padding: 0;
      border: none;
      background-color: transparent;
      cursor: pointer;
      position: relative;
      display: inline-block;
  }
  .qbo-link-btn img {
      display: block;
  }
  .qbo-link-btn .hover-state {
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
    transition: opacity 0.1s ease-in-out;
  }
  .qbo-link-btn.hovered .hover-state {
      opacity: 1;
  }

#QBOConnected
{
    background-color: green;
    color: white;
    display: grid;
    place-content: center;
    font-weight: bold;
    width: 150px;
    padding: 10px 0px;
    border-radius: 10px;
    margin-bottom: 20px;
}
</style>